<script setup>
import { ref, onMounted } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: {
    type: String,
    default: 'Chatwoot',
  },
});

const emit = defineEmits(['search', 'close']);

const searchInputRef = ref(null);
const searchQuery = ref('');

onMounted(() => {
  searchInputRef.value.focus();
});

const onInput = e => {
  emit('search', e.target.value);
};

const onClose = () => {
  emit('close');
};

const keyboardEvents = {
  Slash: {
    action: e => {
      e.preventDefault();
      searchInputRef.value.focus();
    },
  },
  Escape: {
    action: () => {
      onClose();
    },
    allowOnFocusedInput: true,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex flex-col py-1">
    <div
      class="mb-1 flex items-center justify-between border-b border-auth-border py-3 dark:border-auth-border-dark"
    >
      <h3
        class="text-base font-semibold text-auth-text dark:text-auth-text-dark"
      >
        {{ title }}
      </h3>
      <Button
        ghost
        xs
        slate
        icon="i-lucide-x"
        class="!rounded-lg !text-auth-muted hover:!bg-auth-soft hover:!text-auth-text dark:!text-auth-muted-dark dark:hover:!bg-auth-soft-dark dark:hover:!text-auth-text-dark"
        @click="onClose"
      />
    </div>

    <div class="relative">
      <div
        class="absolute top-0.5 flex h-8 w-9 items-center justify-center text-auth-muted dark:text-auth-muted-dark ltr:left-0 rtl:right-0"
      >
        <fluent-icon icon="search" class="" size="18" />
      </div>
      <input
        ref="searchInputRef"
        type="text"
        :placeholder="$t('HELP_CENTER.ARTICLE_SEARCH.PLACEHOLDER')"
        class="mb-0 block h-9 w-full rounded-xl border border-auth-border bg-auth-soft text-sm leading-8 text-auth-text outline-none reset-base placeholder:text-auth-muted focus:border-auth-action focus:ring-1 focus:ring-auth-action dark:border-auth-border-dark dark:bg-auth-soft-dark dark:text-auth-text-dark dark:placeholder:text-auth-muted-dark dark:focus:border-auth-accent dark:focus:ring-auth-accent ltr:pl-9 rtl:pr-9"
        :value="searchQuery"
        @input="onInput"
      />
    </div>
  </div>
</template>
